import React from "react";
import Sidebar from "../pages/homepage/components/Sidebar";
import TopHeader from "../pages/homepage/components/TopHeader";

const ScreenWrapper = ({ Component, page }) => {
  return (
    <div className="d-flex">
      <Sidebar page={page} />
      <div className="main-content min-h-screen flex flex-col ">
        <TopHeader />
        <div className="mainarea flex-1">
          <div className="h-full">
            <Component />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenWrapper;
